export const PRICING = {
  net_agency: 0,
  num_pax: 0,
  net_price: 0,
  num_segments: 0,
  final_price: 0,
  markup: 0,
  commission_paid: 0,
  fee: 0,
  taxes_amount: 0,
  comision: 0,
  fare_amount: 0,
  iva: 0,
  over_amount: 0,
  expenses: 0,
  commission_percentage: 0,
  additional_fare: 0,
  additional_cost: 0,
  sale_discount: 0,
  taxes_1: 0,
  taxes_2 : 0,
  taxes_3 : 0,
}
